import { Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadDiscounts } from '~/store/legacy/actions/discountActions.js';
import { selectDiscounts } from '~/store/legacy/selector/discountSelectors.js';
import { selectUserServiceType } from '~/store/legacy/selector/userSelectors.js';
import RestaurantBadges from '../RestaurantBadges';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  restInfo: {
    marginTop: 20,
    marginBottom: 20,
  },
});

function RestaurantInfo(props) {
  const { restaurant, isRestOpen } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { discounts } = useSelector(selectDiscounts);
  const serviceType = useSelector(selectUserServiceType);
  if (!restaurant) {
    return null;
  }
  const discount = discounts[restaurant.id];
  useEffect(() => {
    if (!discount) {
      dispatch(loadDiscounts({ restaurantIds: [restaurant.id], serviceType }));
    }
  }, [discount]);
  const { name, foreignName, subtitle } = restaurant.attributes;
  const {
    address: {
      data: {
        attributes: { address1, city, state },
      },
    },
  } = restaurant.relationships;

  return (
    <div className={classes.restInfo}>
      <Typography variant='h5' style={{ fontFamily: 'proximanova-bold' }}>
        {name} {foreignName} {!isRestOpen && '(Closed)'}{' '}
      </Typography>
      <Typography variant='subtitle1' style={{ color: '#87919d' }}>
        {subtitle}
      </Typography>
      <Typography variant='body2' style={{ color: '#87919d', marginBottom: 10 }}>
        {address1}, {city}, {state}
      </Typography>
      <RestaurantBadges {...restaurant.attributes} discount={discount} serviceType={serviceType} />
    </div>
  );
}

export default RestaurantInfo;
